module.exports = "/lucky-balls/video/intro_ro.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_ro.mp4
// module id = 889
// module chunks = 0